// Glossary (read-only view of the client's Transcription Config glossary)

// The side panel shows a preview; the modal pages through the full list.
export const GLOSSARY_PREVIEW_SIZE = 10;
export const GLOSSARY_PAGE_SIZE = 20;

// Mirrors the client portal's sort cycle. The casing asymmetry between
// 'CreatedOn' and 'name' is what the API expects — do not normalise it.
export const GLOSSARY_SORT_MODES = {
  default: { sortRowName: 'CreatedOn', sortRowDirection: 'DESC' },
  nameAsc: { sortRowName: 'name', sortRowDirection: 'ASC' },
  nameDesc: { sortRowName: 'name', sortRowDirection: 'DESC' },
};

export const GLOSSARY_SORT_CYCLE = ['default', 'nameAsc', 'nameDesc'];

export const GLOSSARY_SORT_LABELS = {
  default: 'Sort',
  nameAsc: 'A–Z',
  nameDesc: 'Z–A',
};

// Shown as the sort button's tooltip: what the next click will do.
export const GLOSSARY_SORT_HINTS = {
  default: 'Sort A to Z',
  nameAsc: 'Sort Z to A',
  nameDesc: 'Sort by newest first',
};

export const GLOSSARY_GENERIC_ERROR = 'Unable to load the glossary. Please try again.';
